import React, { useContext, useEffect } from 'react'
import { useParams, useHistory } from "react-router-dom"
import { BiArrowBack } from 'react-icons/bi'
import { FlexView, LoadingOverlay } from '../components/common'
import JobSummarySubheader from 'app-components/run-in-hole/job-summary/JobSummarySubheader'
import RunInHole from 'app-components/run-in-hole/RunInHole'
// import PreRunning from 'app-components/pre-running/PreRunning'
import { JobContext } from 'stores/JobStore'
// import { useTranslation } from 'react-i18next'
import styled from 'styled-components'


const BackButton = styled.a` 
  align-self: flex-start;
  margin: 24px 0 0 0;
  cursor: pointer;
  color: #777;

  text-decoration: none;
`

const JobDetails = () => {
  const history = useHistory()
  // const { t } = useTranslation()
  const { jobDetailsData, isJobDetailsLoading, setJobId } = useContext(JobContext)
  // const [currentTab, setCurrentTab] = useState(1)
  // const { registryLog, registryLogOld } = useContext(UserContext)
  // const DEFAULT_URL = "running-expert/job-details"

  // const tabs = useMemo(() => [
  //   {
  //     title: t('pre-running'),
  //     content: <PreRunning />
  //   },
  //   {
  //     title: t('run-in hole'),
  //     content: <RunInHole />
  //   }
  // ], [t])

  let { jobId } = useParams()
  useEffect(() => {
    const handleJobIdParam = (id) => {
      if (id) {
        setJobId(id)
      } else {
        history.push('/')
      }
    }
    handleJobIdParam(jobId)
  }, [jobId, history, setJobId])

  return (
    <FlexView width="100%" minHeight="100vh" alignItems="center" justifyContent="flex-start" fontSize="title" fontWeight="bold" backgroundColor="#E5E5E5">
      <LoadingOverlay visible={isJobDetailsLoading} fixed />
      <FlexView width="85%">
        <BackButton href="/">
          <BiArrowBack size="2rem" />
        </BackButton>
        <JobSummarySubheader jobDetailsData={jobDetailsData} ></JobSummarySubheader>
        <RunInHole />
      </FlexView>

    </FlexView>)

}

export default JobDetails
